import uniqueId from 'lodash/uniqueId'

/**
 * Returns a unique string with random set of characters and numbers (e.g. '4vi8ev5q84')
 * @returns {string}
 */
export const generateUUID = () => uniqueId(Math.random().toString(36).substring(2, 10))
